import { Link, usePage } from "@inertiajs/react"
import { Bug, Plus, Users, UserCircle } from "lucide-react"
import type { ReactNode } from "react"

import { matchesPath, newStaffMatchPath, staffUsersPath, staffPlayersPath } from "@/routes"

import PersistentLayout from "./persistent-layout"

interface MatchLayoutProps {
  children: ReactNode
}

export default function MatchLayout({ children }: MatchLayoutProps) {
  const { auth } = usePage().props as {
    auth: { user?: { role: string } | null }
  }
  const isStaff = auth?.user?.role === "admin" || auth?.user?.role === "coach"

  return (
    <PersistentLayout>
      <div className="bg-background min-h-screen">
        <header className="bg-card sticky top-0 z-30 border-b">
          <div className="mx-auto flex h-12 max-w-6xl items-center gap-6 px-4">
            <Link
              href={matchesPath()}
              className="flex items-center gap-2 font-bold"
            >
              <Bug className="text-primary h-5 w-5" />
              <span>Escarabajos</span>
            </Link>
            <nav className="flex items-center gap-1">
              <Link
                href={matchesPath()}
                className="text-muted-foreground hover:bg-muted hover:text-foreground rounded-md px-3 py-1.5 text-sm font-medium transition-colors"
              >
                Matches
              </Link>
              {isStaff && (
                <>
                  <Link
                    href={newStaffMatchPath()}
                    className="text-muted-foreground hover:bg-muted hover:text-foreground flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors"
                  >
                    <Plus className="h-3.5 w-3.5" />
                    Import
                  </Link>
                    <Link
                    href={staffUsersPath()}
                    className="text-muted-foreground hover:bg-muted hover:text-foreground flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors"
                  >
                    <Users className="h-3.5 w-3.5" />
                    Users
                  </Link>
                  <Link
                    href={staffPlayersPath()}
                    className="text-muted-foreground hover:bg-muted hover:text-foreground flex items-center gap-1.5 rounded-md px-3 py-1.5 text-sm font-medium transition-colors"
                  >
                    <UserCircle className="h-3.5 w-3.5" />
                    Players
                  </Link>
                </>
              )}
            </nav>
          </div>
        </header>
        {children}
      </div>
    </PersistentLayout>
  )
}
